import React from "react";

import Authorize from "components/Library/Authorize/Authorize";
import Events from "events/components/Events";
import Subscription from "subscriptions/components/Subscription";
import Subscriptions from "subscriptions/components/Subscriptions";
import NotFound from "components/Library/NotFound";
import SectionStream from "stream/containers/SectionStream";
import TagStream from "stream/containers/TagStream";
import PermalinkStream from "stream/containers/PermalinkStream";
import AuthorStream from "stream/containers/AuthorStream";
import SearchStream from "stream/containers/SearchStream";
import TopSectionStream from "stream/containers/TopSectionStream";
import SmarterFasterSectionStream from "stream/containers/SmarterFasterSectionStream";
import MidtermsTagStream from "stream/containers/MidtermsTagStream";
import RefugeeCrisisTagStream from "stream/containers/RefugeeCrisisTagStream";
import FutureOfRetailTagStream from "stream/containers/FutureOfRetailTagStream";
import DavosTagStream from "stream/containers/DavosTagStream";
import BusinessOfSportsTagStream from "stream/containers/BusinessOfSportsTagStream";
import FutureOfDatingTagStream from "stream/containers/FutureOfDatingTagStream";
import DataPrivacyTagStream from "stream/containers/DataPrivacyTagStream";

import {
  getNewsletter,
  populateSubscription,
} from "subscriptions/actions/subscriptions";
import { getRedirectPath } from "utils/server";
import asyncComponent from "utils/asyncComponent";

import { URL_ID_REGEXP, SECTION, TAG } from "config/constants";

const oldPermalinkRoute = "/:slug([A-Za-z0-9-]+-)?:id([0-9]+).html";
const storyPermalinkRoute = `/:slug([A-Za-z0-9-]+?-)?:id${URL_ID_REGEXP}.html`;
const newsletterPermalinkRoute = `/newsletters/:subscription([A-Za-z0-9-]+?)-:newsletter${URL_ID_REGEXP}.html`;

const AsyncAbout = asyncComponent(() => import("about/components/About/About"));
const AsyncLegal = asyncComponent(() => import("legal/components/Legal/Legal"));
const AsyncUserSettings = asyncComponent(() =>
  import("users/components/UserSettings/UserSettings")
);
const AsyncSavedStories = asyncComponent(() =>
  import("users/components/SavedStories/SavedStories")
);

export const routes = [
  {
    path: "/",
    exact: true,
    component: TopSectionStream,
  },
  {
    path: "/authors/:username",
    exact: true,
    component: AuthorStream,
  },
  {
    path: "/authorize",
    exact: true,
    component: Authorize,
  },
  {
    path: "/results",
    exact: true,
    component: SearchStream,
  },
  {
    path: "/legal",
    exact: true,
    component: AsyncLegal,
  },
  {
    path: "/about",
    exact: true,
    component: AsyncAbout,
  },
  {
    path: "/events",
    exact: true,
    component: Events,
  },
  {
    path: `/:section(${SECTION.SMARTER_FASTER.slug})`,
    exact: true,
    component: SmarterFasterSectionStream,
  },
  {
    path: `/tag/:tag(${TAG.MIDTERM_ELECTIONS_2018.slug})`,
    exact: true,
    component: MidtermsTagStream,
  },
  {
    path: `/tag/:tag(${TAG.REFUGEE_CRISIS.slug})`,
    exact: true,
    component: RefugeeCrisisTagStream,
  },
  {
    path: `/tag/:tag(${TAG.FUTURE_OF_RETAIL.slug})`,
    exact: true,
    component: FutureOfRetailTagStream,
  },
  {
    path: `/tag/:tag(${TAG.DAVOS.slug})`,
    exact: true,
    component: DavosTagStream,
  },
  {
    path: `/tag/:tag(${TAG.BUSINESS_OF_SPORTS.slug})`,
    exact: true,
    component: BusinessOfSportsTagStream,
  },
  {
    path: `/tag/:tag(${TAG.FUTURE_OF_DATING.slug})`,
    exact: true,
    component: FutureOfDatingTagStream,
  },
  {
    path: `/tag/:tag(${TAG.DATA_PRIVACY.slug})`,
    exact: true,
    component: DataPrivacyTagStream,
  },
  {
    path: "/newsletters",
    exact: true,
    component: Subscriptions,
  },
  {
    path: newsletterPermalinkRoute,
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch, context) =>
      Promise.all([
        getRedirectPath(req, match.params.newsletter, context),
        dispatch(getNewsletter(match.params.newsletter)),
        dispatch(populateSubscription(match.params.subscription)),
      ]),
  },
  {
    path: "/newsletters/:subscription",
    exact: true,
    component: Subscription,
    fetchData: (req, match, dispatch) =>
      dispatch(populateSubscription(match.params.subscription)),
  },
  {
    path: "/users/settings",
    exact: true,
    component: AsyncUserSettings,
  },
  {
    path: "/users/saved-stories",
    exact: true,
    component: AsyncSavedStories,
  },
  {
    path: "/tag/:tag",
    exact: true,
    component: TagStream,
  },
  {
    path: storyPermalinkRoute,
    component: PermalinkStream,
    fetchData: (req, match, dispatch, context) => {
      if (req.query.preview || req.query.revision) return Promise.resolve();
      getRedirectPath(req, match.params.id, context);
    },
  },
  {
    path: oldPermalinkRoute,
    render: () => {
      null;
    },
    fetchData: (req, match, dispatch, context) =>
      getRedirectPath(req, match.params.id, context),
  },
  {
    path: "/community/:user",
    fetchData: (req, match, dispatch, context) => {
      context.status = 301;
      context.path = `/authors/${match.params.user}`;
      return Promise.resolve();
    },
  },
  {
    path: "/:section([a-zA-Z-]+)",
    render: props => {
      return <SectionStream {...props} />;
    },
    exact: true,
  },
  // 404 fallback route
  {
    path: "/*",
    render: ({ staticContext }) => {
      if (staticContext) staticContext.status = 404;
      return <NotFound />;
    },
  },
];
